var cssGallery = 'gallery';
var cssGalleryMobile = "".concat(cssGallery, "_mobile");
var cssGalleryBar = "".concat(cssGallery, "-bar");
var cssGalleryBarImageNumbers = "".concat(cssGalleryBar, "__image-numbers");
var cssGalleryBarImageDescription = "".concat(cssGalleryBar, "__image-description");
var cssGalleryBarCopyLink = "".concat(cssGalleryBar, "__copy-link");
var cssGalleryBarCopyLinkConfirmation = "".concat(cssGalleryBarCopyLink, "_confirmation");
var cssGalleryBarCopyLinkConfirmationText = "".concat(cssGalleryBarCopyLink, "_confirmation-text");
var cssGalleryBarImageClose = "".concat(cssGalleryBar, "__image-close");
var cssGalleryImages = "".concat(cssGallery, "__images");
var cssGalleryImagesWithTransition = "".concat(cssGallery, "__images_with-transition");
var cssGalleryImagesContainer = "".concat(cssGalleryImages, "-container");
var cssGalleryImage = "".concat(cssGallery, "__image");
var cssGalleryImageContainer = "".concat(cssGalleryImage, "-container");
var cssGalleryImageAdjusted = "".concat(cssGalleryImage, "_adjusted");
var cssGalleryImageMaxWidth = "".concat(cssGalleryImage, "_max-width");
var cssGalleryImageMaxHeight = "".concat(cssGalleryImage, "_max-height");
var cssIcon = 'icon';
var cssIconArrow = "".concat(cssIcon, "-arrow");
var cssIconArrowContainer = "".concat(cssIconArrow, "-container");
var cssIconArrowContainerPrevious = "".concat(cssIconArrowContainer, "_previous");
var cssIconArrowContainerNext = "".concat(cssIconArrowContainer, "_next");
var cssIconArrowRotate180 = "".concat(cssIconArrow, "_rotate-180");
var cssIconClose = "".concat(cssIcon, "-close");
var cssIconLink = "".concat(cssIcon, "-link");
var cssIconSuccess = "".concat(cssIcon, "-success");
var cssLoaderMask = 'loader__mask';
var cssHide = 'hide';
var cssHideMobile = 'hide_mobile';
var cssHideDesktop = 'hide_desktop';
var cssZoomIn = 'zoom-in';
var cssZoomOut = 'zoom-out';
var cssGrabbing = 'grabbing';

export { cssGallery, cssGalleryBar, cssGalleryBarCopyLink, cssGalleryBarCopyLinkConfirmation, cssGalleryBarCopyLinkConfirmationText, cssGalleryBarImageClose, cssGalleryBarImageDescription, cssGalleryBarImageNumbers, cssGalleryImage, cssGalleryImageAdjusted, cssGalleryImageContainer, cssGalleryImageMaxHeight, cssGalleryImageMaxWidth, cssGalleryImages, cssGalleryImagesContainer, cssGalleryImagesWithTransition, cssGalleryMobile, cssGrabbing, cssHide, cssHideDesktop, cssHideMobile, cssIcon, cssIconArrow, cssIconArrowContainer, cssIconArrowContainerNext, cssIconArrowContainerPrevious, cssIconArrowRotate180, cssIconClose, cssIconLink, cssIconSuccess, cssLoaderMask, cssZoomIn, cssZoomOut };
//# sourceMappingURL=css_classes.js.map
